import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';

interface Props {
    title: string;
    defaultOpen?: boolean;
    children: React.ReactNode;
    icon?: React.ReactNode;
    count?: number;
}

export const CollapsibleSection: React.FC<Props> = ({
    title,
    defaultOpen = false,
    children,
    icon,
    count,
}) => {
    const [open, setOpen] = useState(defaultOpen);

    return (
        <div className="bg-white border border-[#E8E4DB] rounded overflow-hidden">
            <button
                onClick={() => setOpen(!open)}
                className="w-full flex items-center justify-between px-6 py-4 hover:bg-[#F3EFE6] transition-colors text-left"
            >
                <span className="text-[13px] font-medium text-[#1A1A1A] flex items-center gap-2">
                    {icon}
                    {title}
                    {count !== undefined && count > 0 && (
                        <span className="text-[11px] font-mono tabular-nums text-[#6B6762] border border-[#E8E4DB] px-2 py-0.5 rounded">
                            {count}
                        </span>
                    )}
                </span>
                {open
                    ? <ChevronUp className="w-4 h-4 text-[#6B6762] shrink-0" />
                    : <ChevronDown className="w-4 h-4 text-[#6B6762] shrink-0" />}
            </button>
            {open && (
                <div className="animate-in slide-in-from-top-1 duration-200">
                    {children}
                </div>
            )}
        </div>
    );
};
